// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const wattrel: PokeData = {
  "id": 940,
  "name": "wattrel",
  "height": 4,
  "weight": 36,
  "base_experience": 56,
  "types": [
    PokeType.ELECTRIC,
    PokeType.FLYING
  ],
  "api_moves": [
    "growl",
    "peck",
    "thunder-shock",
    "agility",
    "quick-attack",
    "spark",
    "uproar",
    "roost",
    "pluck",
    "discharge",
    "volt-switch",
    "dual-wingbeat"
  ],
  "moves": [
    "growl",
    "peck",
    "thunder-shock",
    "quick-attack",
    "roost",
    "volt-switch",
    "wild-charge",
    "gust",
    "thunder",
    "tailwind",
    "aerial-ace",
    "volt-crash",
    "zap-cannon"
  ],
  "evolution_chain": {
    "id": 492,
    "item": null,
    "species": [
      {
        "name": "wattrel",
        "order": 957,
        "types": [
          PokeType.ELECTRIC,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "kilowattrel",
        "order": 958,
        "types": [
          PokeType.ELECTRIC,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 940,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 38.75,
    "speed": 70,
    "ability_power": 55
  },
  "stat_changes": [],
  "catch_rate": 180,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
